import { useCallback } from 'react';
import { MobileAccountStatButtonSkeletonStyled } from './styled/MobileAccountBoxStyled';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import BinIcon from '../../../components/icon/Icon';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { logAppsflyerAction } from '../../../app/appActions';
import { getUserSelectedAccountType } from '../../../app/appSelectors';
import { getIsShowAccountEventIndicator } from '../../../modules/Notifications/notificationsSelectors';
import NotificationIndicator
    from '../../../modules/Notifications/components/NotificationIndicator/NotificationIndicator';
import { locationSlice } from '../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../modules/Location/locationConstants';

interface IMobileAccountStatButtonProps {
    size?: 'sm' | 'lg',
    variant?: string,
}

function MobileAccountStatButton(props: IMobileAccountStatButtonProps) {
    const { size, variant = 'secondary' } = props;

    const dispatch = useDispatch();
    const accountType = useSelector(getUserSelectedAccountType);
    const isShowNotificationIndicator = useSelector(getIsShowAccountEventIndicator);

    const onStatButtonClickHandler = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.OVERVIEW }));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_ACCOUNT_ANALYTICS,
            payload: { account_type: accountType },
        }));
    }, [accountType, dispatch]);

    if (!accountType) {
        return <MobileAccountStatButtonSkeletonStyled className="wave-background"/>;
    }

    return <Button variant={variant} size={size} className={'square position-relative'}
                   onClick={onStatButtonClickHandler}>
        <BinIcon name={'IcOverviewChart'}/>
        {isShowNotificationIndicator && <NotificationIndicator className={'sm'} top={'8px'} right={'8px'}/>}
    </Button>;
}

export default MobileAccountStatButton;
